var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['text-h6 text-md-h5', _vm.colorClass, _vm.alignClass]},[_c('span',{staticClass:"font-secondary"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }